<template>
  <a-tag :color="getStatusColor(status)">{{ status || "N/A" }}</a-tag>
</template>

<script>
export default {
  name: "StatusTag",
  props: {
    status: {
      type: String,
      required: false,
      default: null,
    },
  },
  methods: {
    getStatusColor(status) {
      if (!status) return "lightgray";
      
      // Normalize status to lowercase for case-insensitive matching
      const normalizedStatus = status.toLowerCase();
      
      const statuses = {
        // Invoice Status
        pending: "orange",
        "partially paid": "gold",
        paid: "green",
        repaid: "green",
        overdue: "red",
        "critically overdue": "volcano",
        cancelled: "gray",
        confirmed: "green",
        failed: "red",
        partial: "orange",
        "pending payable": "orange",

        // Order Status
        new: "blue",
        "awaiting fulfillment": "orange",
        fulfilling: "gold",
        complete: "green",
        canceled: "red",
        received: "green",

        // Factoring
        applied: "blue",
        eligible: "green",
        "not eligible": "red",

        // Disbursement Status
        success: "green",
        processing: "blue",
        completed: "green",
        rejected: "red",

        // Other statuses
        active: "green",
        approved: "green",
        "not verified": "red",
        verified: "green",
        inactive: "red",
        expired: "red",
        delivered: "green",
        draft: "blue",
        "near expiry": "gold",
        "monitor closely": "orange",
        healthy: "green",
        "room temp": "blue",
        "cold chain": "gold",
        "marked as received": "green",
        picked: "green",
        "not picked": "red",
        due: "orange",
        scheduled: "blue",
        unknown: "lightgray",
      };
      return statuses[normalizedStatus] || "lightgray";
    },
  },
};
</script>

<style scoped>
.a-tag {
  display: inline-block;
  width: max-content;
  min-width: 0;
}
</style>
